import React from "react";
import CalendarComponent from "../Components/CalendarComponent";
import LoadingSpinner from "../Components/LoadingSpinner";
import { useAuth } from "../Hooks/AuthProvider";
import { RoomProvider, ClientSideSuspense } from "@liveblocks/react";

function Calendar() {
  const { user } = useAuth();

  if (!user) {
    return <LoadingSpinner />;
  }

  return (
    <RoomProvider id="motion-air-calendar" initialPresence={{ cursor: null }}>
      <ClientSideSuspense fallback={<LoadingSpinner />}>
        <CalendarComponent />
      </ClientSideSuspense>
    </RoomProvider>
  );
}

export default Calendar;
